<template>
  <HeaderComponent />
  <div class="whoreBlock">
    <div class="goBack">
      <img src="../assets/icons/arrowLeft.svg" />
      <p @click="goBack">Назад</p>
    </div>
    <div class="girlBlock" v-if="girl && !isMobile">
      <div class="girlPhoto">
        <PhotoView @close-photo="closePhoto" :girlPhotos="girl" :photoIndex="activePhotoIndex" v-if="isBigPhoto" />
        <div class="photoCarousel">
          <Flicking :options="{ align: 'center', panelsPerView: 1, circular: true, inputType: ['mouse', 'pointer'] }" ref="photoCarousel" @changed="onChangePhoto">
            <div class="flicking-panel" v-for="(image, index) in girl.photos" :key="index">
              <img :src="image.url" alt="Gallery Image" class="gallery-image" @click="isBigPhoto = true" />
            </div>
            <div class="flicking-panel" v-if="girl.photos.length == 0">
              <img src="../assets/img/noPhoto.svg" alt="Gallery Image" class="gallery-image" style="cursor: default" />
            </div>
          </Flicking>
          <span @click="goToPrev" class="flicking-arrow-prev is-thin photo-carousel-arrow"></span>
          <span @click="goToNext" class="flicking-arrow-next is-thin photo-carousel-arrow"></span>
        </div>
        <div class="miniPhotoCarousel">
          <Flicking :options="{ align: 'center', bound: true, moveType: 'freeScroll' }">
            <div class="flicking-mini-panel" v-for="(image, index) in girl.photos" :key="index" @click="goToSlide(index + 1)" :class="{ active: activePhotoIndex === index }">
              <img :src="image.url" alt="Gallery Image" class="mini-gallery-image" />
            </div>
          </Flicking>
        </div>
      </div>
      <div class="infoText">
        <div class="infoTextHead">
          <div class="girlHeadRow">
            <div class="girlName">
              {{ girl.fullName }}
              <div class="verify-wrapper">
                <img v-if="girl.verified" src="../assets/icons/verify.svg" @mouseenter="isGirlVerify = true" @mouseleave="isGirlVerify = false" />
                <div class="verifyPopUp">
                  <p>Эта модель успешно<br />прошла верификацию</p>
                </div>
              </div>
            </div>
            <div class="girlDiscountBadge" v-if="activeDiscount">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_451_2886)">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M8.43562 2.75662C9.45899 -0.829304 14.5409 -0.829304 15.5643 2.75662C15.8911 3.90178 17.0676 4.58104 18.2228 4.29149C21.84 3.3848 24.381 7.7859 21.7872 10.4651C20.9588 11.3207 20.9588 12.6793 21.7872 13.5349C24.381 16.2141 21.84 20.6152 18.2228 19.7085C17.0676 19.419 15.8911 20.0982 15.5643 21.2434C14.5409 24.8293 9.45899 24.8293 8.43562 21.2434C8.1088 20.0982 6.93229 19.419 5.77714 19.7085C2.15995 20.6152 -0.381026 16.2141 2.21279 13.5349C3.04112 12.6793 3.04112 11.3207 2.21279 10.4651C-0.381025 7.7859 2.15995 3.3848 5.77714 4.29149C6.93229 4.58104 8.1088 3.90178 8.43562 2.75662ZM15.1872 8.81282C15.4801 9.10571 15.4801 9.58058 15.1872 9.87348L9.53033 15.5303C9.23744 15.8232 8.76256 15.8232 8.46967 15.5303C8.17678 15.2374 8.17678 14.7626 8.46967 14.4697L14.1265 8.81282C14.4194 8.51992 14.8943 8.51992 15.1872 8.81282ZM9 10C8.44772 10 8 9.55232 8 9.00004C8 8.44775 8.44772 8.00004 9 8.00004C9.55228 8.00004 10 8.44775 10 9.00004C10 9.55232 9.55228 10 9 10ZM15 16C14.4477 16 14 15.5523 14 15C14 14.4478 14.4477 14 15 14C15.5523 14 16 14.4478 16 15C16 15.5523 15.5523 16 15 16Z"
                    fill="#4DCAFF"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_451_2886">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <span> {{ activeDiscount.percent }}% </span>
            </div>
          </div>
          <p class="girl_desc">{{ girl.description }}</p>
        </div>
        <div class="infoBlock">
          <div class="pinkFeatures">
            <div class="pinkFeature">
              <span class="pinkFeatureLabel">Возраст</span>
              <span class="pinkFeatureValue">{{ girl.age }} {{ getPluralForm(girl.age) }}</span>
            </div>
            <div class="pinkFeature">
              <span class="pinkFeatureLabel">Грудь</span>
              <span class="pinkFeatureValue">{{ girl.boobsSize }}</span>
            </div>
            <div class="pinkFeature">
              <span class="pinkFeatureLabel">Вес</span>
              <span class="pinkFeatureValue">{{ girl.weight }} кг</span>
            </div>
            <div class="pinkFeature">
              <span class="pinkFeatureLabel">Рост</span>
              <span class="pinkFeatureValue">{{ girl.height }} см</span>
            </div>
          </div>
          <div class="blueFeatures">
            <div class="blueFeature" v-if="girl.individual">Индивидуалка</div>
            <div class="blueFeature" v-if="girl.escort">Эскорт</div>
            <div class="blueFeature" v-if="girl.slut">Проститутка</div>
            <div class="blueFeature" v-if="girl.massage">Массажистка</div>
            <div class="blueFeature" v-if="girl.premium">Премиум</div>
            <div class="blueFeature" v-if="girl.elite">Элитная</div>
          </div>
          <div class="grayFeatures">
            <div class="grayFeature">{{ nationality }}</div>
            <div class="grayFeature">{{ appearance }} внешность</div>
            <div class="grayFeature">{{ place }}</div>
            <div class="grayFeature" v-if="girl.ageRestriction">Ограничение по возрасту: от {{ girl.ageRestriction }} лет</div>
          </div>
        </div>
        <div class="reservationBlock">
          <div class="hourRent">
            <div class="infoHour infoHourPink">
              <img src="../assets/icons/hearts.svg" alt="" class="icon_bg" />
              <img src="../assets/icons/clock1h.svg" class="infoHourIcon" />
              <div class="infoHourLabel">1 час</div>
              <div class="priceStack" v-if="activeDiscount">
                <div class="priceOld">{{ formatPrice(girl.oneHourPrice) }}<span>₽</span></div>
                <div class="priceDiscount">{{ formatPrice(getDiscountedPrice(girl.oneHourPrice)) }}<span>₽</span></div>
              </div>
              <div class="priceSum" v-else>{{ formatPrice(girl.oneHourPrice) }}<span>₽</span></div>
            </div>
            <div class="infoHour infoHourPink">
              <img src="../assets/icons/hearts.svg" alt="" class="icon_bg" />
              <img src="../assets/icons/clock2h.svg" class="infoHourIcon infoHourIconWide" />
              <div class="infoHourLabel">2 часа</div>
              <div class="priceStack" v-if="activeDiscount">
                <div class="priceOld">{{ formatPrice(getTwoHourPrice()) }}<span>₽</span></div>
                <div class="priceDiscount">{{ formatPrice(getDiscountedPrice(getTwoHourPrice())) }}<span>₽</span></div>
              </div>
              <div class="priceSum" v-else>{{ formatPrice(getTwoHourPrice()) }}<span>₽</span></div>
            </div>
            <div class="infoHour infoHourNight">
              <img src="../assets/icons/clouds.svg" alt="" class="icon_bg" />
              <img src="../assets/icons/moonNight.svg" class="infoHourIcon" />
              <div class="infoHourLabel infoHourLabelNight">
                <span>ночь</span>
              </div>
              <div class="priceStack" v-if="activeDiscount">
                <div class="priceOld">{{ formatPrice(girl.nightPrice) }}<span>₽</span></div>
                <div class="priceDiscount priceDiscountNight">{{ formatPrice(getDiscountedPrice(girl.nightPrice)) }}<span>₽</span></div>
              </div>
              <div class="priceSum" v-else>{{ formatPrice(girl.nightPrice) }}<span>₽</span></div>
            </div>
          </div>
          <div class="reservation_wrapper">
            <button class="reservationButton" @click="openReservationModal">Забронировать</button>
            <Transition name="fade">
              <ReservationComponent v-if="isReservationOpen" @close-auth="openReservationModal" :girlId="this.girl._id" :oneHourPrice="this.girl.oneHourPrice" :nightPrice="this.girl.nightPrice" />
            </Transition>
            <div class="heartBlock">
              <Transition name="fade">
                <img src="../assets/icons/favouriteSelected.svg" @click="addToFavourite" v-if="isFavouriteGirl" />
                <img src="../assets/icons/favourite.svg" @click="addToFavourite" v-else />
              </Transition>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="girlBlock" v-if="girl && isMobile">
      <div class="girlPhoto">
        <div class="infoTextHeadMobile">
          <div class="infoTextHead">
            <div class="girlHeadRow">
              <div class="girlName">
                <p class="infoTextHeadName">{{ girl.fullName }}</p>
                <div class="verify-wrapper">
                  <img v-if="girl.verified" src="../assets/icons/verify.svg" @mouseenter="isGirlVerify = true" @mouseleave="isGirlVerify = false" />
                  <div class="verifyPopUp">
                    <p>Эта модель успешно<br />прошла верификацию</p>
                  </div>
                </div>
              </div>
              <div class="girlDiscountBadge mobileGirlDiscountBadge" v-if="activeDiscount">{{ activeDiscount.percent }}%</div>
            </div>
          </div>
          <div class="heartBlock">
            <Transition name="fade">
              <img src="../assets/icons/favouriteSelected.svg" @click="addToFavourite" v-if="isFavouriteGirl" />
              <img src="../assets/icons/favourite.svg" @click="addToFavourite" v-else />
            </Transition>
          </div>
        </div>
        <PhotoView @close-photo="closePhoto" :girlPhotos="girl" :photoIndex="activePhotoIndex" v-if="isBigPhoto" />
        <div class="photoCarousel">
          <Flicking :options="{ align: 'center', panelsPerView: 1, circular: true, inputType: ['mouse', 'pointer'] }" :plugins="carouselPlugins" ref="photoCarousel" @changed="onChangePhoto">
            <div class="flicking-panel" v-for="(image, index) in girl.photos" :key="index">
              <img :src="image.url" alt="Gallery Image" class="gallery-image" @click="isBigPhoto = true" />
            </div>

            <div class="flicking-panel" v-if="girl.photos.length == 0">
              <img src="../assets/img/noPhoto.svg" alt="Gallery Image" class="gallery-image" @click="isBigPhoto = true" />
            </div>
          </Flicking>
          <span @click="goToPrev" class="flicking-arrow-prev is-thin photo-carousel-arrow"></span>
          <span @click="goToNext" class="flicking-arrow-next is-thin photo-carousel-arrow"></span>
        </div>

        <div class="miniPhotoCarousel">
          <Flicking :options="{ align: 'center', panelsPerView: girl.photos.length * 1.5, circular: false, bound: true, transition: 100 }" :plugins="carouselPlugins">
            <div class="flicking-mini-panel" v-for="(image, index) in girl.photos" :key="index" @click="goToSlide(index + 1)" :class="{ active: activePhotoIndex === index }">
              <img :src="image.url" alt="Gallery Image" class="mini-gallery-image" />
            </div>
          </Flicking>
        </div>
      </div>
      <div class="infoText">
        <div class="infoTextHead" style="margin-top: 3%; margin-bottom: 3%">
          <p class="girl_desc">{{ girl.description }}</p>
        </div>
        <div class="infoBlock">
          <div class="pinkFeatures">
            <div class="pinkFeature">
              <span class="pinkFeatureLabel">Возраст</span>
              <span class="pinkFeatureValue">{{ girl.age }} {{ getPluralForm(girl.age) }}</span>
            </div>
            <div class="pinkFeature">
              <span class="pinkFeatureLabel">Грудь</span>
              <span class="pinkFeatureValue">{{ girl.boobsSize }}</span>
            </div>
            <div class="pinkFeature">
              <span class="pinkFeatureLabel">Вес</span>
              <span class="pinkFeatureValue">{{ girl.weight }} кг</span>
            </div>
            <div class="pinkFeature">
              <span class="pinkFeatureLabel">Рост</span>
              <span class="pinkFeatureValue">{{ girl.height }} см</span>
            </div>
          </div>
          <div class="blueFeatures">
            <div class="blueFeature" v-if="girl.individual">Индивидуалка</div>
            <div class="blueFeature" v-if="girl.escort">Эскорт</div>
            <div class="blueFeature" v-if="girl.slut">Проститутка</div>
            <div class="blueFeature" v-if="girl.massage">Массажистка</div>
            <div class="blueFeature" v-if="girl.premium">Премиум</div>
            <div class="blueFeature" v-if="girl.elite">Элитная</div>
          </div>
          <div class="grayFeatures">
            <div class="grayFeature">{{ nationality }}</div>
            <div class="grayFeature">{{ appearance }} внешность</div>
            <div class="grayFeature">{{ place }}</div>
            <div class="grayFeature" v-if="girl.ageRestriction">Ограничение по возрасту: от {{ girl.ageRestriction }} лет</div>
          </div>
        </div>

        <div class="hourRentWrapper">
          <div class="hourRent">
            <div class="infoHour infoHourPink">
              <img src="../assets/icons/hearts.svg" alt="" class="icon_bg" />
              <img src="../assets/icons/clock1h.svg" class="infoHourIcon" />
              <div class="infoHourLabel">1 час</div>
              <div class="priceStack" v-if="activeDiscount">
                <div class="priceOld">{{ formatPrice(girl.oneHourPrice) }}<span>₽</span></div>
                <div class="priceDiscount">{{ formatPrice(getDiscountedPrice(girl.oneHourPrice)) }}<span>₽</span></div>
              </div>
              <div class="priceSum" v-else>{{ formatPrice(girl.oneHourPrice) }}<span>₽</span></div>
            </div>
            <div class="infoHour infoHourPink">
              <img src="../assets/icons/hearts.svg" alt="" class="icon_bg" />
              <img src="../assets/icons/clock2h.svg" class="infoHourIcon infoHourIconWide" />
              <div class="infoHourLabel">2 часа</div>
              <div class="priceStack" v-if="activeDiscount">
                <div class="priceOld">{{ formatPrice(getTwoHourPrice()) }}<span>₽</span></div>
                <div class="priceDiscount">{{ formatPrice(getDiscountedPrice(getTwoHourPrice())) }}<span>₽</span></div>
              </div>
              <div class="priceSum" v-else>{{ formatPrice(getTwoHourPrice()) }}<span>₽</span></div>
            </div>
            <div class="infoHour infoHourNight">
              <img src="../assets/icons/clouds.svg" alt="" class="icon_bg" />
              <img src="../assets/icons/moonNight.svg" class="infoHourIcon" />
              <div class="infoHourLabel infoHourLabelNight">
                <span>ночь</span>
              </div>
              <div class="priceStack" v-if="activeDiscount">
                <div class="priceOld">{{ formatPrice(girl.nightPrice) }}<span>₽</span></div>
                <div class="priceDiscount priceDiscountNight">{{ formatPrice(getDiscountedPrice(girl.nightPrice)) }}<span>₽</span></div>
              </div>
              <div class="priceSum" v-else>{{ formatPrice(girl.nightPrice) }}<span>₽</span></div>
            </div>
          </div>
        </div>
        <div class="reservationBlock">
          <button class="reservationButton" @click="openReservationModal">Забронировать</button>
          <Transition name="fade">
            <ReservationComponent v-if="isReservationOpen" @close-auth="openReservationModal" :girlId="this.girl._id" :oneHourPrice="this.girl.oneHourPrice" :nightPrice="this.girl.nightPrice" />
          </Transition>
        </div>
      </div>
    </div>
    <div class="preferencesBlock">
      <p class="preferencesBlockTitle">Предпочтения</p>
      <div class="preferencesCategories">
        <div class="preferencesCategory" v-for="p in preferences" v-bind:key="p">
          <p class="preferenceHeadText">{{ getCategoryText(p.category) }}</p>
          <div class="preferencesCategoryList">
            <div class="preferenceItem" v-for="elem in p.names" v-bind:key="elem">{{ elem }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="reviewsBlock">
      <p style="margin-bottom: 30px">Отзывы</p>
      <div class="reviewBlock" v-for="r in reviews" v-bind:key="r">
        <div class="reviewHead">
          <p>{{ r.reviewerName }}</p>
        </div>
        <p class="reviewText">{{ checkReview(r.text) }}</p>
      </div>
    </div>
  </div>
  <FooterComponent />
</template>

<script>
import FooterComponent from "@/components/FooterComponent.vue";
import HeaderComponent from "@/components/HeaderComponent.vue";
import ReservationComponent from "@/components/ReservationComponent.vue";
import PhotoView from "@/components/PhotoView.vue";
import axios from "axios";
import { ref } from "vue";
import { useToast } from "vue-toastification";
import Flicking from "@egjs/vue3-flicking";
import "../styles/arrow.css";

export default {
  name: "WhorePage",
  data() {
    return {
      girl: null,
      nationality: "",
      appearance: "",
      ageRestriction: "",
      place: "",
      city: this.$store.getters.getCity,
      isBigPhoto: false,
      images: [],
      galleryConfig: {
        itemsToShow: 1,
        wrapAround: true,
        mouseDrag: false,
        touchDrag: false,
      },
      preferences: null,
      isFavouriteGirl: false,
      isReservationOpen: false,
      categs: {
        SEX: "Секс",
        EXTREME: "Экстрим",
        MASSAGE: "Массаж",
        ETC: "Другое",
        STRIPTEASE: "Стриптиз",
        BDSM: "БДСМ",
      },
      reviews: [],
      activePhotoIndex: 0,
      isMobile: false,
      discounts: [],
    };
  },
  computed: {
    activeDiscount() {
      return this.discounts.filter((discount) => !discount.girlId || String(discount.girlId) === String(this.girl?._id)).sort((a, b) => (b.percent || 0) - (a.percent || 0))[0] || null;
    },
  },
  methods: {
    getImage(imagePath) {
      return imagePath;
    },
    goBack() {
      window.history.back();
    },

    getGirl() {
      axios
        .get(`https://${process.env.VUE_APP_SERVERHOST}/api/girl/${this.$route.params.id}`, {
          headers: {
            Authorization: "Bearer " + this.$store.state.userData.token,
          },
        })
        .then((res) => {
          this.girl = res.data.result;
          this.preferences = res.data.result.preference.reduce((acc, item) => {
            if (!acc[item.category]) {
              acc[item.category] = { category: item.category, names: [] };
            }
            acc[item.category].names.push(item.name);
            return acc;
          }, {});
          const sortOrder = ["SEX", "MASSAGE", "EXTREME", "BDSM", "STRIPTEASE", "ETC"];
          this.isFavouriteGirl = this.girl.inFavorite;
          this.preferences = Object.fromEntries(
            // eslint-disable-next-line
            sortOrder.map((key) => [key, this.preferences[key]]).filter(([key, value]) => value),
          );
          console.log(this.girl);
          switch (this.girl.appearance) {
            case "SLAVENIAN":
              this.appearance = "Славянская";
              break;
            case "ASIAN":
              this.appearance = "Азиатская";
              break;
          }
          const nationalities = [
            { name: "RUSSIAN", local: "Русская" },
            { name: "TATARIAN", local: "Татарка" },
            { name: "AZERBAIJANIAN", local: "Азербайджанка" },
            { name: "UKRAINIAN", local: "Украинка" },
            { name: "KAZAKHNIAN", local: "Казашка" },
          ];
          const nat = nationalities.find((item) => item.name === this.girl.nationality);
          this.nationality = nat.local;
          const places = [
            { name: "YOU", local: "У тебя" },
            { name: "ME", local: "У меня" },
            { name: "YOUME", local: "У тебя или у меня" },
          ];
          const pl = places.find((item) => item.name === this.girl.place);
          this.place = pl.local;
          console.log(this.girl.ageRestriction);
          if (this.girl.ageRestriction) this.ageRestriction = this.girl.ageRestriction;
          this.reviews = this.girl.reviews;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCategoryText(category) {
      return this.categs[category] || "Неизвестная категория";
    },
    closePhoto() {
      this.isBigPhoto = false;
    },
    checkReview(text) {
      if (text[0] == '"' && text[text.length - 1] == '"') return text.slice(1, -1);
      else return text;
    },
    getPluralForm(number) {
      let forms = ["год", "года", "лет"];
      number = Math.abs(number) % 100;
      const lastDigit = number % 10;
      if (number > 10 && number < 20) return forms[2];
      if (lastDigit === 1) return forms[0];
      if (lastDigit >= 2 && lastDigit <= 4) return forms[1];
      return forms[2];
    },
    formatPrice(value) {
      if (value == null) return "0";
      return Number(value).toLocaleString("ru-RU");
    },
    getTwoHourPrice() {
      return this.girl?.twoHourPrice || this.girl?.oneHourPrice * 2 || 0;
    },
    getDiscountedPrice(value) {
      if (!this.activeDiscount) return value;
      const discount = (value * this.activeDiscount.percent) / 100;
      return Math.round(value - discount);
    },
    getDiscounts() {
      axios
        .get(`https://${process.env.VUE_APP_SERVERHOST}/api/discount`, {
          headers: {
            Authorization: "Bearer " + this.$store.state.userData.token,
          },
        })
        .then((res) => {
          this.discounts = Array.isArray(res.data?.result) ? res.data.result : [];
        })
        .catch((err) => {
          this.discounts = [];
          console.log(err);
        });
    },
    addToFavourite() {
      if (this.isFavouriteGirl) {
        this.isFavouriteGirl = !this.isFavouriteGirl;
      } else {
        this.isFavouriteGirl = !this.isFavouriteGirl;
      }
      axios.put(
        `https://${process.env.VUE_APP_SERVERHOST}/api/favorite/${this.$route.params.id}`,
        {},
        {
          headers: {
            Authorization: "Bearer " + this.$store.state.userData.token,
          },
        },
      );
    },
    openReservationModal() {
      if (this.isReservationOpen) {
        this.isReservationOpen = false;
      } else {
        this.isReservationOpen = true;
      }
    },
    goToSlide(index) {
      this.$refs.photoCarousel.moveTo(index - 1);
      console.log(index);
    },
    onChangePhoto(e) {
      this.activePhotoIndex = e.index; // Индекс текущей панели
    },
  },
  mounted() {
    this.getGirl();
    this.getDiscounts();
    this.isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  },
  setup() {
    const toast = useToast();
    const photoCarousel = ref(0);
    const goToPrev = () => {
      photoCarousel.value.prev().catch(() => void 0);
    };

    const goToNext = () => {
      photoCarousel.value.next().catch(() => void 0);
    };

    return { toast, goToPrev, goToNext, photoCarousel };
  },
  components: {
    HeaderComponent,
    FooterComponent,
    Flicking,
    ReservationComponent,
    PhotoView,
  },
};
</script>
<style scoped>
.whoreBlock {
  width: 64vw;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.goBack {
  display: flex;
  gap: 5px;
  margin-top: 3%;
  margin-bottom: 3%;
  cursor: pointer;
  width: fit-content;
}
.goBack p {
  font-weight: 600;
}
.girlBlock {
  display: grid;
  grid-template-columns: 1fr 2fr;
  width: 100%;
  margin-bottom: 5%;
}
.photoCarousel {
  position: relative;
}
.miniPhotoCarousel {
  /* height: 50px; */
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
}
.girlPhoto {
  width: 25rem;
  margin: 0 auto;
}
:deep(.thumbnail-image) {
  height: 50px;
  cursor: pointer;
  transition: opacity 0.3s ease-in-out;
  image-rendering: optimizeQuality;
  image-resolution: 1dpi;
}
.gallery-image {
  height: 600px;
  width: 100%;
  border-radius: 12px;
  cursor: pointer;
  object-fit: cover;
}
.mini-gallery-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 6px;
}
.pinkFeatures {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 15px;
}
.blueFeatures {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}
.grayFeatures {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
  margin-bottom: 5%;
}
.pinkFeature {
  background-color: #ff898926;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 6px 0;
  text-align: center;
  width: 5.5rem;
}
.pinkFeatureLabel {
  font-size: 14px;
  font-weight: 600;
  color: #f78383;
}
.pinkFeatureValue {
  font-size: 14px;
  font-weight: 700;
  color: #8f5555;
}
.blueFeature {
  background-color: #89bfff26;
  color: #89bfff;
  font-size: 13px;
  font-weight: 600;
  border-radius: 10px;
  padding: 5px 10px;
}
.grayFeature {
  background-color: #f6f6f6;
  color: #757575;
  font-size: 13px;
  font-weight: 600;
  border-radius: 10px;
  padding: 5px 10px;
  width: fit-content;
}
.infoBlock {
  width: 100%;
}
.infoText {
  margin-left: 20px;
}
.infoTextHead {
  gap: 5px;
  display: flex;
  flex-direction: column;
}
.girlHeadRow {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}
.infoTextHeadMobile {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5%;
}
.infoTextHeadName {
  font-size: 24px;
  font-weight: 600;
}
.infoTextHeadCity {
  font-size: 14px;
  font-weight: 400;
  color: #757575;
}
.girlName {
  font-size: 32px;
  font-weight: 600;
  display: flex;
  gap: 5px;
  align-items: center;
  position: relative;
}
.girl_desc {
  background-color: #f6f6f6;
  color: #757575;
  padding: 0.8rem;
  border-radius: 0.8rem;
}

.verifyPopUp {
  position: absolute;
  bottom: 125%; /* выше иконки */
  left: 50%;
  transform: translateX(-50%);
  background-color: #2f2f2f;
  color: #fff;
  padding: 6px 10px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s;
  z-index: 10;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.verifyPopUp p {
  display: flex;
  align-items: center;
  margin-bottom: 0 !important;
  font-size: 14px;
  font-weight: 500;
}

.verify-wrapper:hover .verifyPopUp {
  opacity: 1;
}
.reservationBlock {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 25px;
  width: 50%;
}
.girlDiscountBadge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 66px;
  padding: 7px 12px;
  border-radius: 12px;
  background-color: #4dcaff26;
  color: #4dcaff;
  font-size: 13px;
  font-weight: 700;
  flex-shrink: 0;
  gap: 0.5rem;
}
.hourRentWrapper {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobileGirlDiscountBadge {
  margin-top: 2px;
}
.reservation_wrapper img {
  cursor: pointer;
  transition: 0.3s;
}
.reservation_wrapper img:hover {
  filter: drop-shadow(0 0 2px #5b5b5bb0);
  transition: 0.3s;
}
.reservation_wrapper {
  display: flex;
  gap: 10px;
  align-items: center;
  position: relative;
}
.reservationButton {
  background-color: #2f2f2f;
  border-radius: 10px;
  border: 1px solid #2f2f2f;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  color: #ffffff;
  padding: 10px 50px;
  cursor: pointer;
}
.hourRent {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}
.infoHour {
  display: flex;
  align-items: center;
  gap: 12px;
  border-radius: 12px;
  padding: 12px 16px;
  position: relative;
  overflow: hidden;
  border-bottom: 2px solid white;
}
.hourRent > div:nth-child(1) {
  border-radius: 0.8rem 0.8rem 0 0;
}
.hourRent > div:nth-child(2) {
  border-radius: 0;
}
.hourRent > div:nth-child(3) {
  border-radius: 0 0 0.8rem 0.8rem;
}
.icon_bg {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0.3rem;
}
.infoHourPink {
  background-color: #ff767f;
}
.infoHourNight {
  background-color: #1b4365;
}
.infoHourIcon {
  position: absolute;
  top: 50%;
  right: 14px;
  transform: translateY(-50%);
  width: 28px;
  height: auto;
}
.infoHourIconWide {
  width: 36px;
}
.infoHourLabel {
  background-color: #ffffff;
  color: #ff767f;
  font-size: 16px;
  font-weight: 700;
  border-radius: 20px;
  padding: 4px 0;
  width: 4.8rem;
  text-transform: lowercase;
  white-space: nowrap;
  flex-shrink: 0;
  text-align: center;
}
.infoHourLabelNight {
  color: white;
  background-color: #3871a1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.infoHourLabelNight span {
  font-size: 16px;
  letter-spacing: 0.5px;
}
.priceSum {
  display: flex;
  align-items: baseline;
  gap: 2px;
  color: #ffffff;
  font-size: 1rem;
  font-weight: 700;
  position: relative;
  z-index: 1;
}
.priceSum span {
  font-family: "Noto Sans";
  font-size: 15px;
  font-weight: 600;
  color: #ffffff;
}
.priceStack {
  display: flex;
  align-items: center;
  gap: 14px;
  position: relative;
  z-index: 1;
  flex-wrap: wrap;
}
.priceOld {
  display: flex;
  align-items: baseline;
  gap: 2px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 1rem;
  font-weight: 700;
  text-decoration: line-through;
}
.priceOld span {
  font-family: "Noto Sans";
  font-size: 15px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.7);
}
.priceDiscount {
  display: flex;
  align-items: baseline;
  gap: 2px;
  color: #ffffff;
  font-size: 1rem;
  font-weight: 700;
  background-color: rgba(255, 255, 255, 0.16);
  padding: 6px 14px;
  border-radius: 18px;
}
.priceDiscount span {
  font-family: "Noto Sans";
  font-size: 15px;
  font-weight: 600;
  color: #ffffff;
}
.priceDiscountNight {
  background-color: rgba(56, 113, 161, 0.45);
}
:deep(.carousel__icon) {
  fill: white;
  width: 30px;
  height: 30px;
}
:deep(.carousel__item) {
  width: 100%;
}
:deep(.carousel__next),
:deep(.carousel__prev) {
  fill: white;
  background-color: #2f2f2f80;
  border-radius: 40px;
  width: 40px;
  height: 40px;
}

:deep(.carousel__prev) {
  margin-left: -20px;
}
:deep(.carousel__next) {
  margin-right: -20px;
}
:deep(.carousel__item img) {
  width: 100%;
  border-radius: 5px;
  object-fit: cover;
}
#thumbnails {
  margin-top: 10px;
}
.preferencesBlock {
  width: 100%;
  margin-bottom: 50px;
}
.preferencesBlockTitle {
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 30px;
}
.preferencesCategories {
  column-count: 2;
  column-gap: 40px;
}
.preferencesCategory {
  break-inside: avoid;
  margin-bottom: 40px;
  display: inline-block;
  width: 100%;
}
.preferenceHeadText {
  margin-bottom: 15px !important;
  font-size: 20px !important;
  font-weight: 600 !important;
  color: #2f2f2f;
}
.preferencesCategoryList {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.preferenceItem {
  background-color: #f6f6f6;
  color: #333333;
  font-size: 14px;
  font-weight: 500;
  border-radius: 0.8rem;
  padding: 0.8rem;
  width: 48%;
}
.reviewsBlock p {
  font-size: 32px;
  font-weight: 600;
}
.reviewsBlock {
  margin-bottom: 7%;
}
.reviewBlock {
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  background-color: #f6fafd;
  padding: 30px;
  margin-bottom: 20px;
}
.reviewHead {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
.reviewHead p:nth-child(1) {
  font-size: 18px !important;
}
.reviewHead p:nth-child(2) {
  font-size: 18px !important;
  font-weight: 400 !important;
  color: #757575;
}
.reviewText {
  color: #757575;
  font-size: 18px !important;
  font-weight: 400 !important;
}
.heartBlock {
  width: 51px;
  height: 51px;
  position: absolute;
  left: 103%;
}
.heartBlock img {
  position: absolute;
}
.flicking-panel {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-right: 20px;
}

.flicking-panel img {
  -webkit-user-drag: none;
  width: 100%;
  object-fit: cover;
}
.flicking-mini-panel {
  width: 80px;
  height: 80px;
  margin-right: 10px;
  border-radius: 8px;
  cursor: pointer;
  opacity: 0.6;
  transition: opacity 0.3s, border 0.3s;
  border: 2px solid transparent;
}
.flicking-mini-panel img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  -webkit-user-drag: none;
  border-radius: 7px;
  cursor: pointer;
}
.flicking-mini-panel.active {
  opacity: 1;
  border-color: #ff767f;
}
.photo-carousel-arrow {
  width: 50px !important;
  height: 50px !important;
  background-color: rgba(0, 0, 0, 0.4) !important;
  border-radius: 50%;
  z-index: 10;
  padding: 2rem;
}
.flicking-arrow-prev.photo-carousel-arrow {
  left: -25px !important;
}
.flicking-arrow-prev.photo-carousel-arrow::before,
.flicking-arrow-prev.photo-carousel-arrow::after {
  background-color: white !important;
}
.flicking-arrow-next.photo-carousel-arrow {
  right: -25px !important;
}
.flicking-arrow-next.photo-carousel-arrow::before,
.flicking-arrow-next.photo-carousel-arrow::after {
  background-color: white !important;
}
@media (max-width: 1760px) {
  .reservationBlock {
    width: 60%;
  }
}
@media (max-width: 1530px) {
  .reservationBlock {
    width: 70%;
  }
}
@media (max-width: 1300px) {
  .whoreBlock {
    width: 80vw;
  }
  .reservationBlock {
    width: 70%;
  }
}
@media (max-width: 1200px) {
  .headInfoHour p {
    font-size: 14px;
  }
}
@media (max-width: 968px) {
  .whoreBlock {
    width: 80%;
  }
  .girlBlock {
    display: flex;
    flex-direction: column;
    margin-top: 5%;
  }
  .girlPhoto {
    width: 100%;
  }
  .infoTextHead {
    gap: 0px;
  }
  .girlHeadRow {
    align-items: center;
    gap: 10px;
  }
  .infoText {
    margin-left: 0;
  }
  .infoBlock {
    width: 100%;
  }
  .reservationButton {
    width: 100%;
  }
  .grayFeatures {
    margin-bottom: 5%;
  }
  .hourRent {
    margin-bottom: 5%;
  }
  .preferencesCategoryList div {
    font-size: 16px;
  }
  .reviewText {
    font-size: 16px !important;
  }
  .reservationBlock {
    width: 100%;
  }
  .preferencesCategories {
    column-count: 1;
  }

  .infoTextHeadMobile {
    align-items: center;
  }
  .girlDiscountBadge {
    min-width: 60px;
    padding: 6px 10px;
    font-size: 12px;
  }
  .heartBlock {
    position: relative;
    left: 0;
  }
}
</style>
